!function(t, e) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = "undefined" != typeof globalThis ? globalThis : t || self).TTSEditor = e()
}(this, function() {
    "use strict";
    function t(t) {
        return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t
    }
    function e(t, e) {
        return t(e = {
            exports: {}
        }, e.exports),
        e.exports
    }
    var d = t(e(function(t) {
        function c(t, e, n, r, o, a, i) {
            try {
                var s = t[a](i)
                  , c = s.value
            } catch (t) {
                return void n(t)
            }
            s.done ? e(c) : Promise.resolve(c).then(r, o)
        }
        t.exports = function(s) {
            return function() {
                var t = this
                  , i = arguments;
                return new Promise(function(e, n) {
                    var r = s.apply(t, i);
                    function o(t) {
                        c(r, e, n, o, a, "next", t)
                    }
                    function a(t) {
                        c(r, e, n, o, a, "throw", t)
                    }
                    o(void 0)
                }
                )
            }
        }
        ,
        t.exports.default = t.exports,
        t.exports.__esModule = !0
    }))
      , h = t(e(function(t) {
        t.exports = function(t, e) {
            if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function")
        }
        ,
        t.exports.default = t.exports,
        t.exports.__esModule = !0
    }))
      , p = t(e(function(t) {
        function r(t, e) {
            for (var n = 0; n < e.length; n++) {
                var r = e[n];
                r.enumerable = r.enumerable || !1,
                r.configurable = !0,
                "value"in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r)
            }
        }
        t.exports = function(t, e, n) {
            return e && r(t.prototype, e),
            n && r(t, n),
            t
        }
        ,
        t.exports.default = t.exports,
        t.exports.__esModule = !0
    }))
      , o = t(e(function(t) {
        t.exports = function(t, e, n) {
            return e in t ? Object.defineProperty(t, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t[e] = n,
            t
        }
        ,
        t.exports.default = t.exports,
        t.exports.__esModule = !0
    }))
      , r = e(function(t) {
        t.exports = function(t, e) {
            for (var n = 0, r = Array(e = null == e || e > t.length ? t.length : e); n < e; n++)
                r[n] = t[n];
            return r
        }
        ,
        t.exports.default = t.exports,
        t.exports.__esModule = !0
    });
    t(r);
    var n = e(function(t) {
        t.exports = function(t) {
            if (Array.isArray(t))
                return r(t)
        }
        ,
        t.exports.default = t.exports,
        t.exports.__esModule = !0
    });
    t(n);
    var a = e(function(t) {
        t.exports = function(t) {
            if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"])
                return Array.from(t)
        }
        ,
        t.exports.default = t.exports,
        t.exports.__esModule = !0
    });
    t(a);
    var i = e(function(t) {
        t.exports = function(t, e) {
            if (t) {
                if ("string" == typeof t)
                    return r(t, e);
                var n = Object.prototype.toString.call(t).slice(8, -1);
                return "Map" === (n = "Object" === n && t.constructor ? t.constructor.name : n) || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? r(t, e) : void 0
            }
        }
        ,
        t.exports.default = t.exports,
        t.exports.__esModule = !0
    });
    t(i);
    var s = e(function(t) {
        t.exports = function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }
        ,
        t.exports.default = t.exports,
        t.exports.__esModule = !0
    });
    t(s);
    var w = t(e(function(t) {
        t.exports = function(t) {
            return n(t) || a(t) || i(t) || s()
        }
        ,
        t.exports.default = t.exports,
        t.exports.__esModule = !0
    }))
      , f = e(function(e) {
        e = function(i) {
            var c, t = Object.prototype, l = t.hasOwnProperty, e = "function" == typeof Symbol ? Symbol : {}, r = e.iterator || "@@iterator", n = e.asyncIterator || "@@asyncIterator", o = e.toStringTag || "@@toStringTag";
            function a(t, e, n) {
                return Object.defineProperty(t, e, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }),
                t[e]
            }
            try {
                a({}, "")
            } catch (t) {
                a = function(t, e, n) {
                    return t[e] = n
                }
            }
            function s(t, e, n, r) {
                var o, a, i, s, e = Object.create((e && e.prototype instanceof v ? e : v).prototype), r = new E(r || []);
                return e._invoke = (o = t,
                a = n,
                i = r,
                s = d,
                function(t, e) {
                    if (s === p)
                        throw Error("Generator is already running");
                    if (s === f) {
                        if ("throw" === t)
                            throw e;
                        return N()
                    }
                    for (i.method = t,
                    i.arg = e; ; ) {
                        var n = i.delegate;
                        if (n) {
                            var r = function t(e, n) {
                                var r = e.iterator[n.method];
                                if (r === c) {
                                    if (n.delegate = null,
                                    "throw" === n.method) {
                                        if (e.iterator.return && (n.method = "return",
                                        n.arg = c,
                                        t(e, n),
                                        "throw" === n.method))
                                            return m;
                                        n.method = "throw",
                                        n.arg = new TypeError("The iterator does not provide a 'throw' method")
                                    }
                                    return m
                                }
                                var r = u(r, e.iterator, n.arg);
                                if ("throw" === r.type)
                                    return n.method = "throw",
                                    n.arg = r.arg,
                                    n.delegate = null,
                                    m;
                                r = r.arg;
                                if (!r)
                                    return n.method = "throw",
                                    n.arg = new TypeError("iterator result is not an object"),
                                    n.delegate = null,
                                    m;
                                {
                                    if (!r.done)
                                        return r;
                                    n[e.resultName] = r.value,
                                    n.next = e.nextLoc,
                                    "return" !== n.method && (n.method = "next",
                                    n.arg = c)
                                }
                                n.delegate = null;
                                return m
                            }(n, i);
                            if (r) {
                                if (r === m)
                                    continue;
                                return r
                            }
                        }
                        if ("next" === i.method)
                            i.sent = i._sent = i.arg;
                        else if ("throw" === i.method) {
                            if (s === d)
                                throw s = f,
                                i.arg;
                            i.dispatchException(i.arg)
                        } else
                            "return" === i.method && i.abrupt("return", i.arg);
                        s = p;
                        r = u(o, a, i);
                        if ("normal" === r.type) {
                            if (s = i.done ? f : h,
                            r.arg !== m)
                                return {
                                    value: r.arg,
                                    done: i.done
                                }
                        } else
                            "throw" === r.type && (s = f,
                            i.method = "throw",
                            i.arg = r.arg)
                    }
                }
                ),
                e
            }
            function u(t, e, n) {
                try {
                    return {
                        type: "normal",
                        arg: t.call(e, n)
                    }
                } catch (t) {
                    return {
                        type: "throw",
                        arg: t
                    }
                }
            }
            i.wrap = s;
            var d = "suspendedStart"
              , h = "suspendedYield"
              , p = "executing"
              , f = "completed"
              , m = {};
            function v() {}
            function g() {}
            function y() {}
            var b = {};
            b[r] = function() {
                return this
            }
            ;
            e = Object.getPrototypeOf,
            e = e && e(e(T([])));
            e && e !== t && l.call(e, r) && (b = e);
            var x = y.prototype = v.prototype = Object.create(b);
            function w(t) {
                ["next", "throw", "return"].forEach(function(e) {
                    a(t, e, function(t) {
                        return this._invoke(e, t)
                    })
                })
            }
            function k(i, s) {
                var e;
                this._invoke = function(n, r) {
                    function t() {
                        return new s(function(t, e) {
                            !function e(t, n, r, o) {
                                t = u(i[t], i, n);
                                if ("throw" !== t.type) {
                                    var a = t.arg;
                                    return (n = a.value) && "object" == typeof n && l.call(n, "__await") ? s.resolve(n.__await).then(function(t) {
                                        e("next", t, r, o)
                                    }, function(t) {
                                        e("throw", t, r, o)
                                    }) : s.resolve(n).then(function(t) {
                                        a.value = t,
                                        r(a)
                                    }, function(t) {
                                        return e("throw", t, r, o)
                                    })
                                }
                                o(t.arg)
                            }(n, r, t, e)
                        }
                        )
                    }
                    return e = e ? e.then(t, t) : t()
                }
            }
            function S(t) {
                var e = {
                    tryLoc: t[0]
                };
                1 in t && (e.catchLoc = t[1]),
                2 in t && (e.finallyLoc = t[2],
                e.afterLoc = t[3]),
                this.tryEntries.push(e)
            }
            function _(t) {
                var e = t.completion || {};
                e.type = "normal",
                delete e.arg,
                t.completion = e
            }
            function E(t) {
                this.tryEntries = [{
                    tryLoc: "root"
                }],
                t.forEach(S, this),
                this.reset(!0)
            }
            function T(e) {
                if (e) {
                    var t = e[r];
                    if (t)
                        return t.call(e);
                    if ("function" == typeof e.next)
                        return e;
                    if (!isNaN(e.length)) {
                        var n = -1
                          , t = function t() {
                            for (; ++n < e.length; )
                                if (l.call(e, n))
                                    return t.value = e[n],
                                    t.done = !1,
                                    t;
                            return t.value = c,
                            t.done = !0,
                            t
                        };
                        return t.next = t
                    }
                }
                return {
                    next: N
                }
            }
            function N() {
                return {
                    value: c,
                    done: !0
                }
            }
            return ((g.prototype = x.constructor = y).constructor = g).displayName = a(y, o, "GeneratorFunction"),
            i.isGeneratorFunction = function(t) {
                t = "function" == typeof t && t.constructor;
                return !!t && (t === g || "GeneratorFunction" === (t.displayName || t.name))
            }
            ,
            i.mark = function(t) {
                return Object.setPrototypeOf ? Object.setPrototypeOf(t, y) : (t.__proto__ = y,
                a(t, o, "GeneratorFunction")),
                t.prototype = Object.create(x),
                t
            }
            ,
            i.awrap = function(t) {
                return {
                    __await: t
                }
            }
            ,
            w(k.prototype),
            k.prototype[n] = function() {
                return this
            }
            ,
            i.AsyncIterator = k,
            i.async = function(t, e, n, r, o) {
                void 0 === o && (o = Promise);
                var a = new k(s(t, e, n, r),o);
                return i.isGeneratorFunction(e) ? a : a.next().then(function(t) {
                    return t.done ? t.value : a.next()
                })
            }
            ,
            w(x),
            a(x, o, "Generator"),
            x[r] = function() {
                return this
            }
            ,
            x.toString = function() {
                return "[object Generator]"
            }
            ,
            i.keys = function(n) {
                var t, r = [];
                for (t in n)
                    r.push(t);
                return r.reverse(),
                function t() {
                    for (; r.length; ) {
                        var e = r.pop();
                        if (e in n)
                            return t.value = e,
                            t.done = !1,
                            t
                    }
                    return t.done = !0,
                    t
                }
            }
            ,
            i.values = T,
            E.prototype = {
                constructor: E,
                reset: function(t) {
                    if (this.prev = 0,
                    this.next = 0,
                    this.sent = this._sent = c,
                    this.done = !1,
                    this.delegate = null,
                    this.method = "next",
                    this.arg = c,
                    this.tryEntries.forEach(_),
                    !t)
                        for (var e in this)
                            "t" == (e[0] || "") && l.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = c)
                },
                stop: function() {
                    this.done = !0;
                    var t = this.tryEntries[0].completion;
                    if ("throw" === t.type)
                        throw t.arg;
                    return this.rval
                },
                dispatchException: function(n) {
                    if (this.done)
                        throw n;
                    var r = this;
                    function t(t, e) {
                        return a.type = "throw",
                        a.arg = n,
                        r.next = t,
                        e && (r.method = "next",
                        r.arg = c),
                        !!e
                    }
                    for (var e = this.tryEntries.length - 1; 0 <= e; --e) {
                        var o = this.tryEntries[e]
                          , a = o.completion;
                        if ("root" === o.tryLoc)
                            return t("end");
                        if (o.tryLoc <= this.prev) {
                            var i = l.call(o, "catchLoc")
                              , s = l.call(o, "finallyLoc");
                            if (i && s) {
                                if (this.prev < o.catchLoc)
                                    return t(o.catchLoc, !0);
                                if (this.prev < o.finallyLoc)
                                    return t(o.finallyLoc)
                            } else if (i) {
                                if (this.prev < o.catchLoc)
                                    return t(o.catchLoc, !0)
                            } else {
                                if (!s)
                                    throw Error("try statement without catch or finally");
                                if (this.prev < o.finallyLoc)
                                    return t(o.finallyLoc)
                            }
                        }
                    }
                },
                abrupt: function(t, e) {
                    for (var n = this.tryEntries.length - 1; 0 <= n; --n) {
                        var r = this.tryEntries[n];
                        if (r.tryLoc <= this.prev && l.call(r, "finallyLoc") && this.prev < r.finallyLoc) {
                            var o = r;
                            break
                        }
                    }
                    var a = (o = !(!o || "break" !== t && "continue" !== t || e < o.tryLoc || o.finallyLoc < e) ? null : o) ? o.completion : {};
                    return a.type = t,
                    a.arg = e,
                    o ? (this.method = "next",
                    this.next = o.finallyLoc,
                    m) : this.complete(a)
                },
                complete: function(t, e) {
                    if ("throw" === t.type)
                        throw t.arg;
                    return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg,
                    this.method = "return",
                    this.next = "end") : "normal" === t.type && e && (this.next = e),
                    m
                },
                finish: function(t) {
                    for (var e = this.tryEntries.length - 1; 0 <= e; --e) {
                        var n = this.tryEntries[e];
                        if (n.finallyLoc === t)
                            return this.complete(n.completion, n.afterLoc),
                            _(n),
                            m
                    }
                },
                catch: function(t) {
                    for (var e = this.tryEntries.length - 1; 0 <= e; --e) {
                        var n = this.tryEntries[e];
                        if (n.tryLoc === t) {
                            var r, o = n.completion;
                            return "throw" === o.type && (r = o.arg,
                            _(n)),
                            r
                        }
                    }
                    throw Error("illegal catch attempt")
                },
                delegateYield: function(t, e, n) {
                    return this.delegate = {
                        iterator: T(t),
                        resultName: e,
                        nextLoc: n
                    },
                    "next" === this.method && (this.arg = c),
                    m
                }
            },
            i
        }(e.exports);
        try {
            regeneratorRuntime = e
        } catch (t) {
            Function("r", "regeneratorRuntime = r")(e)
        }
    });
    function c() {}
    function m() {
        m.init.call(this)
    }
    function l(t) {
        return void 0 === t._maxListeners ? m.defaultMaxListeners : t._maxListeners
    }
    function u(t, e, n, r) {
        var o, a;
        if ("function" != typeof n)
            throw new TypeError('"listener" argument must be a function');
        return (o = t._events) ? (o.newListener && (t.emit("newListener", e, n.listener || n),
        o = t._events),
        a = o[e]) : (o = t._events = new c,
        t._eventsCount = 0),
        a ? ("function" == typeof a ? a = o[e] = r ? [n, a] : [a, n] : r ? a.unshift(n) : a.push(n),
        a.warned || (r = l(t)) && 0 < r && r < a.length && (a.warned = !0,
        (r = Error("Possible EventEmitter memory leak detected. " + a.length + " " + e + " listeners added. Use emitter.setMaxListeners() to increase limit")).name = "MaxListenersExceededWarning",
        r.emitter = t,
        r.type = e,
        r.count = a.length,
        r = r,
        "function" == typeof console.warn ? console.warn(r) : console.log(r))) : (a = o[e] = n,
        ++t._eventsCount),
        t
    }
    function v(t, e, n) {
        var r = !1;
        function o() {
            t.removeListener(e, o),
            r || (r = !0,
            n.apply(t, arguments))
        }
        return o.listener = n,
        o
    }
    function g(t) {
        var e = this._events;
        if (e) {
            t = e[t];
            if ("function" == typeof t)
                return 1;
            if (t)
                return t.length
        }
        return 0
    }
    function y(t, e) {
        for (var n = Array(e); e--; )
            n[e] = t[e];
        return n
    }
    function b(e, t) {
        var n, r = Object.keys(e);
        return Object.getOwnPropertySymbols && (n = Object.getOwnPropertySymbols(e),
        t && (n = n.filter(function(t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable
        })),
        r.push.apply(r, n)),
        r
    }
    function k(e) {
        for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? b(Object(n), !0).forEach(function(t) {
                o(e, t, n[t])
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : b(Object(n)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
            })
        }
        return e
    }
    c.prototype = Object.create(null),
    (m.EventEmitter = m).usingDomains = !1,
    m.prototype.domain = void 0,
    m.prototype._events = void 0,
    m.prototype._maxListeners = void 0,
    m.defaultMaxListeners = 10,
    m.init = function() {
        this.domain = null,
        m.usingDomains && (void 0).active,
        this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = new c,
        this._eventsCount = 0),
        this._maxListeners = this._maxListeners || void 0
    }
    ,
    m.prototype.setMaxListeners = function(t) {
        if ("number" != typeof t || t < 0 || isNaN(t))
            throw new TypeError('"n" argument must be a positive number');
        return this._maxListeners = t,
        this
    }
    ,
    m.prototype.getMaxListeners = function() {
        return l(this)
    }
    ,
    m.prototype.emit = function(t) {
        var e, n, r, o = "error" === t, a = this._events;
        if (a)
            o = o && null == a.error;
        else if (!o)
            return !1;
        if (i = this.domain,
        o) {
            if (o = arguments[1],
            i)
                return (o = o || Error('Uncaught, unspecified "error" event')).domainEmitter = this,
                o.domain = i,
                o.domainThrown = !1,
                i.emit("error", o),
                !1;
            if (o instanceof Error)
                throw o;
            var i = Error('Uncaught, unspecified "error" event. (' + o + ")");
            throw i.context = o,
            i
        }
        if (!(e = a[t]))
            return !1;
        var s, c = "function" == typeof e;
        switch (s = arguments.length) {
        case 1:
            !function(t, e, n) {
                if (e)
                    t.call(n);
                else
                    for (var r = t.length, o = y(t, r), a = 0; a < r; ++a)
                        o[a].call(n)
            }(e, c, this);
            break;
        case 2:
            !function(t, e, n, r) {
                if (e)
                    t.call(n, r);
                else
                    for (var o = t.length, a = y(t, o), i = 0; i < o; ++i)
                        a[i].call(n, r)
            }(e, c, this, arguments[1]);
            break;
        case 3:
            !function(t, e, n, r, o) {
                if (e)
                    t.call(n, r, o);
                else
                    for (var a = t.length, i = y(t, a), s = 0; s < a; ++s)
                        i[s].call(n, r, o)
            }(e, c, this, arguments[1], arguments[2]);
            break;
        case 4:
            !function(t, e, n, r, o, a) {
                if (e)
                    t.call(n, r, o, a);
                else
                    for (var i = t.length, s = y(t, i), c = 0; c < i; ++c)
                        s[c].call(n, r, o, a)
            }(e, c, this, arguments[1], arguments[2], arguments[3]);
            break;
        default:
            for (n = Array(s - 1),
            r = 1; r < s; r++)
                n[r - 1] = arguments[r];
            !function(t, e, n, r) {
                if (e)
                    t.apply(n, r);
                else
                    for (var o = t.length, a = y(t, o), i = 0; i < o; ++i)
                        a[i].apply(n, r)
            }(e, c, this, n)
        }
        return !0
    }
    ,
    m.prototype.addListener = function(t, e) {
        return u(this, t, e, !1)
    }
    ,
    m.prototype.on = m.prototype.addListener,
    m.prototype.prependListener = function(t, e) {
        return u(this, t, e, !0)
    }
    ,
    m.prototype.once = function(t, e) {
        if ("function" != typeof e)
            throw new TypeError('"listener" argument must be a function');
        return this.on(t, v(this, t, e)),
        this
    }
    ,
    m.prototype.prependOnceListener = function(t, e) {
        if ("function" != typeof e)
            throw new TypeError('"listener" argument must be a function');
        return this.prependListener(t, v(this, t, e)),
        this
    }
    ,
    m.prototype.removeListener = function(t, e) {
        var n, r, o, a, i;
        if ("function" != typeof e)
            throw new TypeError('"listener" argument must be a function');
        if (!(r = this._events))
            return this;
        if (!(n = r[t]))
            return this;
        if (n === e || n.listener && n.listener === e)
            0 == --this._eventsCount ? this._events = new c : (delete r[t],
            r.removeListener && this.emit("removeListener", t, n.listener || e));
        else if ("function" != typeof n) {
            for (o = -1,
            a = n.length; 0 < a--; )
                if (n[a] === e || n[a].listener && n[a].listener === e) {
                    i = n[a].listener,
                    o = a;
                    break
                }
            if (o < 0)
                return this;
            if (1 === n.length) {
                if (n[0] = void 0,
                0 == --this._eventsCount)
                    return this._events = new c,
                    this;
                delete r[t]
            } else
                !function(t, e) {
                    for (var n = e, r = n + 1, o = t.length; r < o; n += 1,
                    r += 1)
                        t[n] = t[r];
                    t.pop()
                }(n, o);
            r.removeListener && this.emit("removeListener", t, i || e)
        }
        return this
    }
    ,
    m.prototype.removeAllListeners = function(t) {
        var e, n = this._events;
        if (!n)
            return this;
        if (!n.removeListener)
            return 0 === arguments.length ? (this._events = new c,
            this._eventsCount = 0) : n[t] && (0 == --this._eventsCount ? this._events = new c : delete n[t]),
            this;
        if (0 === arguments.length) {
            for (var r, o = Object.keys(n), a = 0; a < o.length; ++a)
                "removeListener" !== (r = o[a]) && this.removeAllListeners(r);
            return this.removeAllListeners("removeListener"),
            this._events = new c,
            this._eventsCount = 0,
            this
        }
        if ("function" == typeof (e = n[t]))
            this.removeListener(t, e);
        else if (e)
            for (; this.removeListener(t, e[e.length - 1]),
            e[0]; )
                ;
        return this
    }
    ,
    m.prototype.listeners = function(t) {
        var e = this._events
          , n = e && (n = e[t]) ? "function" == typeof n ? [n.listener || n] : function(t) {
            for (var e = Array(t.length), n = 0; n < e.length; ++n)
                e[n] = t[n].listener || t[n];
            return e
        }(n) : [];
        return n
    }
    ,
    m.listenerCount = function(t, e) {
        return "function" == typeof t.listenerCount ? t.listenerCount(e) : g.call(t, e)
    }
    ,
    m.prototype.listenerCount = g,
    m.prototype.eventNames = function() {
        return 0 < this._eventsCount ? Reflect.ownKeys(this._events) : []
    }
    ;
    var S = {
        vcn: "vcn",
        speed: "speed",
        intonation: "intonation",
        volume: "volume",
        number: "number",
        composite_vcn: "composite_vcn"
    }
      , _ = {
        min: 10,
        max: 50,
        optimal: 20,
        warning: 120,
        danger: 300
    }
      , x = /((。”)|(？”)|(！”)|(…”)|\n|：|。|？|！|，|；|;|,|!|\?|……|([A-Za-z\s]\.))/g
      , E = /((。”)|(？”)|(！”)|(…”)|\n|：|。|？|！|，|；|;|,|!|\?|……|([A-Za-z\s]\.))$/
      , T = /^((。”)|(？”)|(！”)|(…”)|\n|：|。|？|！|，|；|([A-Za-z\s]\.)|;|,|!|\?|……)/;
    function N(t) {
        return E.test(t = null == t ? "" : t)
    }
    function C(t) {
        return T.test(t.trim())
    }
    var L = {
        status: ""
    };
    function O(e, t) {
        var r, o = !1, a = [], i = [];
        (1 < arguments.length && void 0 !== t ? t : []).forEach(function(t) {
            o = !1,
            a = [],
            i = e.querySelectorAll(t),
            e.querySelectorAll(t + ".mark-range-start").length !== e.querySelectorAll(t + ".mark-range-end").length && (i.forEach(function(t, e) {
                var n;
                null !== (n = t.classList) && void 0 !== n && n.contains("tts-mark-range") && ((r = null === (n = t.classList) || void 0 === n ? void 0 : n.contains("mark-range-start")) === o && a.push(o ? i[e - 1] : t),
                o = r)
            }),
            o && a.push(i[i.length - 1])),
            a.length && a.forEach(function(t) {
                try {
                    t.parentNode.removeChild(t)
                } catch (t) {}
            }),
            a = [],
            i = []
        })
    }
    function A(t) {
        var e, n = t.editorSelector.childNodes[t.editorSelector.childNodes.length - 1];
        n ? n.nodeType === Node.ELEMENT_NODE && "br" == n.nodeName.toLowerCase() ? n.parentNode === t.editorSelector && ((e = document.createElement("div")).classList.add("tts-content-paragraph"),
        e.appendChild(document.createElement("br")),
        t.editorSelector.replaceChild(e, n)) : n.nodeType === Node.TEXT_NODE && ((e = document.createElement("div")).classList.add("tts-content-paragraph"),
        e.appendChild(document.createTextNode(n.nodeValue)),
        t.editorSelector.replaceChild(e, n)) : ((n = document.createElement("div")).classList.add("tts-content-paragraph"),
        n.appendChild(document.createElement("br")),
        t.editorSelector.appendChild(n))
    }
    function D(t) {
        var e = window.getSelection();
        if (e.rangeCount) {
            var n = e.getRangeAt(0)
              , e = document.createRange();
            e.selectNode(t.editorSelector);
            t = n.compareBoundaryPoints(Range.START_TO_START, e),
            e = n.compareBoundaryPoints(Range.END_TO_END, e);
            return 0 <= t && e <= 0
        }
    }
    function R() {
        var t = window.getSelection();
        if (t.rangeCount) {
            var e = t.getRangeAt(0)
              , n = e.commonAncestorContainer.nodeType === Node.TEXT_NODE ? e.commonAncestorContainer.parentNode : e.commonAncestorContainer;
            if (null !== (t = n.classList) && void 0 !== t && t.contains("tts-mark-flag") && e.collapsed) {
                for (var r = 0; r < n.parentNode.childNodes.length && n.parentNode.childNodes[r] !== n; )
                    r++;
                e.setStart(n.parentNode, r + 1),
                e.setEnd(n.parentNode, r + 1),
                e.collapse()
            }
        }
    }
    var j = window.queryPath = function(t, e, n) {
        var r = [];
        return t !== e && t ? void 0 !== n && t.nodeType === Node.ELEMENT_NODE ? j(t = t.childNodes[n], e) : (t.parentNode && (r.push(Array.prototype.slice.call(t.parentNode.childNodes, 0).indexOf(t)),
        r = j(t.parentNode, e).concat(r)),
        r) : r
    }
    ;
    function M(t, e, n) {
        var r = t.end
          , o = t.endOffset
          , a = j(t.start, n, t.startOffset)
          , i = j(r, n, o)
          , s = n.querySelectorAll(e);
        if (s.length) {
            var c = s.length - 1;
            for (var l = []; 0 <= c; )
                (function(t, e, n) {
                    var r = 0 < arguments.length && void 0 !== t ? t : []
                      , o = 1 < arguments.length && void 0 !== e ? e : []
                      , a = 2 < arguments.length && void 0 !== n ? n : []
                      , r = w(r)
                      , o = w(o)
                      , a = w(a)
                      , i = !1
                      , s = !1
                      , c = Math.max(r.length, o.length);
                    if (r.length < c)
                        for (var l = r.length; l < c; )
                            r.push(0),
                            l++;
                    if (o.length < c)
                        for (var u = o.length; u < c; )
                            o.push(0),
                            u++;
                    for (var d = 0, i = !0; d < c; ) {
                        if (r[d] < o[d]) {
                            i = !1;
                            break
                        }
                        d++
                    }
                    if (!i)
                        return !1;
                    var h = Math.max(r.length, a.length);
                    if (r.length < h)
                        for (var p = r.length; p < h; )
                            r.push(0),
                            p++;
                    if (a.length < h)
                        for (var f = a.length; f < h; )
                            a.push(0),
                            f++;
                    for (var s = !0, m = 0; m < h && a[m] <= r[m]; ) {
                        if (a[m] < r[m]) {
                            s = !1;
                            break
                        }
                        m++
                    }
                    return i && s
                }
                )(j(s[c], n), a, i) && l.push(s[c]),
                c--;
            l.forEach(function(t) {
                t.parentNode.removeChild(t)
            })
        }
    }
    function P(t) {
        var e, n, r, o = window.getSelection();
        o.rangeCount && D(t) && (n = function(t) {
            var n = document.createElement("div");
            n.classList.add("tts-content-paragraph"),
            t.childNodes.forEach(function(t) {
                var e;
                t.nodeType === Node.TEXT_NODE && t.nodeValue || t.nodeType === Node.ELEMENT_NODE && null !== (e = t.classList) && void 0 !== e && e.contains("tts-mark-flag") ? n.appendChild(t.cloneNode(!0)) : t.innerText && n.appendChild(document.createTextNode(t.innerText))
            }),
            n.childNodes.length || n.appendChild(document.createElement("br"));
            return n
        }((t = function t(e) {
            var n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : document.body;
            var r = 2 < arguments.length ? arguments[2] : void 0;
            n = n || document.body;
            if (r(e))
                return e;
            if (e === n)
                return null;
            return t(e.parentNode, n, r)
        }((e = o.getRangeAt(0)).endContainer, t.editorSelector, function(t) {
            var e;
            return !(t.nodeType !== Node.ELEMENT_NODE || null === (e = t.classList) || void 0 === e || !e.contains("tts-content-paragraph"))
        })) ? ((r = document.createRange()).setStart(e.endContainer, e.endOffset),
        n = ((n = t.childNodes[t.childNodes.length - 1]).nodeType === Node.TEXT_NODE ? n.nodeValue : n.childNodes).length,
        r.setEnd(t.childNodes[t.childNodes.length - 1], n),
        r.extractContents()) : document.createDocumentFragment()),
        r = document.createRange(),
        t ? r.selectNode(t) : (r.setStart(e.startContainer, e.startOffset),
        r.setEnd(e.endContainer, e.endOffset)),
        r.collapse(),
        r.insertNode(n),
        t ? r.setStartBefore(n) : r.setStartAfter(n),
        o.removeAllRanges(),
        o.addRange(r),
        r.collapse(!0))
    }
    function F(t, e, n) {
        n = 2 < arguments.length && void 0 !== n ? n : [];
        return t.parentNode ? (n.unshift(Array.from(t.parentNode.childNodes).indexOf(t)),
        t.parentNode === e || t.parentNode === document.documentElement ? n : F(t.parentNode, e, n)) : n
    }
    function V(t, e) {
        for (var n = null, r = e; t.length && r.childNodes.length; )
            r = n = r.childNodes[t.shift()];
        return n
    }
    function q(t) {
        var e, n, r, o, a = window.getSelection();
        a.rangeCount && D(t) && ((e = a.getRangeAt(0)).collapsed && (r = null,
        e.commonAncestorContainer.nodeType === Node.ELEMENT_NODE ? (r = null === (r = null === (a = e.commonAncestorContainer.childNodes[e.startOffset]) || void 0 === a ? void 0 : a.previousSibling) || void 0 === r || null === (n = r.classList) || void 0 === n || !n.contains("tts-mark-flag") ? null : r) && e.setStartBefore(r) : e.commonAncestorContainer.nodeType === Node.TEXT_NODE && 0 === e.startOffset && (null !== (r = (null === (r = e.commonAncestorContainer.previousSibling) || void 0 === r ? void 0 : r.nodeType) === Node.TEXT_NODE && !r.nodeValue ? e.commonAncestorContainer.previousSibling : r) && void 0 !== r && null !== (o = r.classList) && void 0 !== o && o.contains("tts-mark-flag") ? e.setStartBefore(r) : r || (!(r = e.commonAncestorContainer.parentNode).previousSibling || null !== (o = r.previousSibling.classList) && void 0 !== o && o.contains("tts-content-paragraph") ? (e.setStartBefore(r),
        e.setEndAfter(r),
        e.collapse(!0)) : e.selectNode(r.previousSibling))))),
        setTimeout(function() {
            t.editorSelector.querySelectorAll("span").forEach(function(t) {
                t.parentNode.replaceChild(document.createTextNode(t.innerText), t)
            })
        }, 0),
        setTimeout(function() {
            O(t.editorSelector, [".tts-mark-vcn", ".tts-mark-composite-vcn", ".tts-mark-number", ".tts-mark-speed", ".tts-mark-intonation", ".tts-mark-volume"])
        })
    }
    function H(t) {
        var n = 0 < arguments.length && void 0 !== t ? t : {}
          , r = document.createElement("i");
        return r.classList.add("tts-mark-flag"),
        r.classList.add("tts-mark-point"),
        r.setAttribute("contenteditable", !1),
        Object.keys(n || {}).forEach(function(t) {
            var e;
            switch (t) {
            case "tts":
                r.setAttribute("data-tts", n.tts);
                break;
            case "label":
                r.setAttribute("data-label", n.label);
                break;
            case "markType":
                r.setAttribute("data-type", n.markType);
                break;
            case "text":
                n.text && (r.innerText = n.text);
                break;
            case "className":
                ((null === (e = n.className) || void 0 === e ? void 0 : e.split(" ")) || []).forEach(function(t) {
                    t && r.classList.add(t)
                })
            }
        }),
        r
    }
    function I(t) {
        var n = 0 < arguments.length && void 0 !== t ? t : {}
          , r = document.createElement("i");
        return r.classList.add("tts-mark-flag"),
        r.classList.add("tts-mark-range"),
        r.setAttribute("contenteditable", !1),
        Object.keys(n || {}).forEach(function(t) {
            var e;
            switch (t) {
            case "tts":
                r.setAttribute("data-tts", n.tts);
                break;
            case "label":
                r.setAttribute("data-label", n.label);
                break;
            case "className":
                ((null === (e = n.className) || void 0 === e ? void 0 : e.split(" ")) || []).forEach(function(t) {
                    t && r.classList.add(t)
                });
                break;
            case "markType":
                r.setAttribute("data-type", n.markType);
                break;
            case "intonation":
                "composite_vcn" === n.markType && r.setAttribute("data-intonation", n.intonation);
                break;
            case "volume":
                "composite_vcn" === n.markType && r.setAttribute("data-volume", n.volume);
                break;
            case "speed":
                "composite_vcn" === n.markType && r.setAttribute("data-speed", n.speed);
                break;
            default:
                r.setAttribute("data-".concat(t), n[t])
            }
        }),
        "start" === n.type ? ((t = document.createElement("i")).classList.add("tts-range-remove"),
        t.setAttribute("contenteditable", !1),
        t.style.userSelect = "none",
        r.prepend(t),
        "composite_vcn" === n.markType && ((t = document.createElement("i")).classList.add("tts-start-prefix-icon"),
        t.setAttribute("contenteditable", !1),
        t.style.userSelect = "none",
        r.prepend(t)),
        r.classList.add("mark-range-start")) : r.classList.add("mark-range-end"),
        r
    }
    function K(t) {
        return (1 === t.length ? t.replace(/\n/, "") : t).length
    }
    function B(t, e) {
        if ("previousSibling" === (1 < arguments.length && void 0 !== e ? e : "previousSibling")) {
            if (!t.previousSibling)
                return null;
            for (var n = t.previousSibling; n && n.nodeType === Node.TEXT_NODE && !n.nodeValue; )
                n = n.previousSibling;
            return n
        }
        if (!t.nextSibling)
            return null;
        for (var r = t.nextSibling; r && r.nodeType === Node.TEXT_NODE && !r.nodeValue; )
            r = r.nextSibling;
        return r
    }
    function W(t, e) {
        var n = e.ttsMarkClass
          , r = e.tts
          , o = e.label
          , a = e.markType
          , i = e.intonation
          , s = e.speed
          , c = e.volume;
        if (!n)
            throw Error("缺失标示的tts标注");
        var l = document.createRange();
        l.setStart(t.currentSelection.startContainer, t.currentSelection.startOffset),
        l.setEnd(t.currentSelection.endContainer, t.currentSelection.endOffset);
        var u = l.startContainer
          , d = l.startOffset
          , h = l.endContainer
          , p = l.endOffset
          , f = l.commonAncestorContainer
          , m = document.createRange();
        m.setEnd(u, d),
        m.setStart(t.editorSelector, 0);
        var v = document.createElement("div");
        v.appendChild(m.cloneContents());
        e = v.querySelectorAll(".".concat(n)),
        m = null;
        e.length && (m = (m = e[e.length - 1]).classList.contains("mark-range-start") ? {
            tts: m.dataset.tts,
            label: m.dataset.label
        } : null);
        v = document.createElement("div");
        v.appendChild(l.cloneContents());
        e = v.querySelectorAll(".".concat(n)),
        v = null;
        e.length && (v = {
            tts: (v = e[e.length - 1]).dataset.tts,
            label: v.dataset.label,
            boundary: v.classList.contains("mark-range-start") ? "start" : "end"
        });
        var g, y, b, x, e = null;
        l.setEnd(h, p),
        l.collapse(),
        v ? "end" === v.boundary ? (g = I({
            className: "".concat(n, " mark-range-end"),
            tts: "".concat(r),
            label: "".concat(o || r),
            type: "end",
            markType: a,
            intonation: i,
            speed: s,
            volume: c
        }),
        (y = document.createDocumentFragment()).appendChild(g),
        l.insertNode(y),
        l.collapse()) : v.tts === r || (g = I({
            className: "".concat(n, " mark-range-end"),
            tts: "".concat(r),
            label: "".concat(o || r),
            type: "end",
            markType: a,
            intonation: i,
            speed: s,
            volume: c
        }),
        (y = document.createDocumentFragment()).appendChild(g),
        l.insertNode(y),
        l.collapse(),
        v = I({
            className: "".concat(n, " mark-range-start"),
            tts: "".concat(v.tts),
            label: "".concat(v.label || v.tts),
            type: "start",
            markType: a,
            intonation: i,
            speed: s,
            volume: c
        }),
        l.insertNode(v),
        l.collapse(),
        e = v) : m ? m.tts === r || (x = I({
            className: "".concat(n, " mark-range-end"),
            tts: "".concat(r),
            label: "".concat(o || r),
            type: "end",
            markType: a,
            intonation: i,
            speed: s,
            volume: c
        }),
        (b = document.createDocumentFragment()).appendChild(x),
        l.insertNode(b),
        l.collapse(),
        x = I({
            className: "".concat(n, " mark-range-start"),
            tts: "".concat(m.tts),
            label: "".concat(m.label || m.tts),
            type: "start",
            markType: a,
            intonation: i,
            speed: s,
            volume: c
        }),
        (b = document.createDocumentFragment()).appendChild(x),
        l.insertNode(b),
        l.collapse(),
        e = x) : (b = I({
            className: "".concat(n, " mark-range-end"),
            tts: "".concat(r),
            label: "".concat(o || r),
            type: "end",
            markType: a,
            intonation: i,
            speed: s,
            volume: c
        }),
        (x = document.createDocumentFragment()).appendChild(b),
        l.insertNode(x),
        l.collapse()),
        M({
            start: u,
            startOffset: d,
            end: h,
            endOffset: p,
            common: f
        }, ".".concat(n), t.editorSelector);
        var w, k, S, _, f = null;
        l.setEnd(u, d),
        l.collapse(),
        m ? m.tts === r || (m = I({
            className: "".concat(n, " mark-range-end"),
            tts: "".concat(m.tts),
            label: "".concat(m.label || m.tts),
            type: "end",
            markType: a,
            intonation: i,
            speed: s,
            volume: c
        }),
        l.insertNode(m),
        l.collapse(),
        f = m,
        m = I({
            className: "".concat(n, " mark-range-start"),
            tts: "".concat(r),
            label: "".concat(o || r),
            type: "start",
            markType: a,
            intonation: i,
            speed: s,
            volume: c
        }),
        l.insertNode(m),
        l.collapse()) : (s = I({
            className: "".concat(n, " mark-range-start"),
            tts: "".concat(r),
            label: "".concat(o || r),
            type: "start",
            markType: a,
            intonation: i,
            speed: s,
            volume: c
        }),
        (c = document.createDocumentFragment()).appendChild(s),
        l.insertNode(c),
        l.collapse()),
        window.getSelection().removeAllRanges(),
        t.currentSelection = null,
        !e || null !== (l = B(e, "nextSibling")) && null !== (w = l.classList) && void 0 !== w && w.contains("mark-range-end") && null !== (k = l.classList) && void 0 !== k && k.contains("".concat(n)) && (e.parentNode.removeChild(l),
        e.parentNode.removeChild(e),
        e = null),
        !f || null !== (e = B(f, "previousSibling")) && null !== (S = e.classList) && void 0 !== S && S.contains("mark-range-start") && null !== (_ = e.classList) && void 0 !== _ && _.contains("".concat(n)) && (f.parentNode.removeChild(e),
        f.parentNode.removeChild(f),
        f = null),
        setTimeout(function() {
            O(t.editorSelector, [".tts-mark-vcn", ".tts-mark-composite-vcn", ".tts-mark-number", ".tts-mark-speed", ".tts-mark-intonation", ".tts-mark-volume"]),
            t.editorSelector.dispatchEvent(new Event("input"))
        })
    }
    function X(t, e, n) {
        var e = 1 < arguments.length && void 0 !== e ? e : (o(r = {}, S.vcn, ""),
        o(r, S.speed, "0"),
        o(r, S.intonation, "50"),
        o(r, S.volume, "50"),
        o(r, S.number, "0"),
        r)
          , r = 2 < arguments.length && void 0 !== n ? n : null;
        n = [];
        return {
            sentences: n,
            cursorIndex: function(t, e) {
                var n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : []
                  , c = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null
                  , l = null
                  , u = null
                  , d = null
                  , h = null
                  , p = null
                  , f = null
                  , m = []
                  , v = !1;
                var g = 0
                  , y = !1
                  , b = !1
                  , x = !1;
                (function n(t, r, i, o) {
                    if (console.log(o),
                    u = h ? k(k({}, r), h) : k({}, r),
                    console.log("::::::", JSON.stringify(h), JSON.stringify(u)),
                    t.nodeType === Node.TEXT_NODE) {
                        c && !y && c.path.join("") === o.join("") && (g = Math.max(i.length - 1, 0),
                        b = !0),
                        C(t.nodeValue) && (v = !1);
                        var s = 0;
                        if (!i.length)
                            return m = $("".concat(t.nodeValue)),
                            b && !y && "".concat(t.nodeValue).length === c.startOffset && (x = !0),
                            void m.forEach(function(t) {
                                i.length ? (v && !C(t.text) || i[i.length - 1]._words < _.min || i[i.length - 1]._words < _.optimal && (!N(i[i.length - 1].content) || i[i.length - 1]._words + t.words < _.max) || U(t.text) ? (i[i.length - 1] = k(k({}, i[i.length - 1]), {}, {
                                    _words: i[i.length - 1]._words + t.words,
                                    content: "".concat(i[i.length - 1].content).concat(t.text),
                                    richText: "".concat(i[i.length - 1].richText).concat(t.text)
                                }),
                                t.text && (v = !1)) : i.push(k(k({}, i[i.length - 1]), {}, {
                                    _words: t.words,
                                    content: "[te".concat(u.intonation, "][n").concat(u.number, "]").concat(t.text),
                                    richText: "".concat(t.text)
                                })),
                                b && !y && ((s += t.words) < c.startOffset || (g = i.length - 1,
                                y = !0))) : (i.push({
                                    tts: k({}, u),
                                    _words: t.words,
                                    content: "[te".concat(u.intonation, "][n").concat(u.number, "]").concat(t.text),
                                    richText: "".concat(t.text)
                                }),
                                b && !y && ((s += t.words) < c.startOffset || (y = !(g = 0))))
                            });
                        !d && !h || (null == d ? void 0 : d[S.vcn]) === (null == h ? void 0 : h[S.vcn]) && (null == d ? void 0 : d[S.speed]) === (null == h ? void 0 : h[S.speed]) && (null == d ? void 0 : d[S.volume]) === (null == h ? void 0 : h[S.volume]) ? (l = i.pop(),
                        b && !y && "".concat(t.nodeValue).length === c.startOffset && (x = !0),
                        d || h ? ((null == d ? void 0 : d[S.intonation]) !== (null == h ? void 0 : h[S.intonation]) && (l.content += "[te".concat((null == h ? void 0 : h[S.intonation]) || r[S.intonation], "]")),
                        (null == d ? void 0 : d[S.number]) !== (null == h ? void 0 : h[S.number]) && (l.content += "[n".concat((null == h ? void 0 : h[S.number]) || r[S.number], "]")),
                        (m = $("".concat(t.nodeValue))).length ? m.forEach(function(t, e) {
                            0 < e && (l = i.pop()),
                            v && !C(t.text) || l._words < _.min || l._words < _.optimal && (!N(l.content) || l._words + t.words < _.max) || U(t.text) ? (l = k(k({}, l), {}, {
                                _words: l._words + t.words,
                                content: "".concat(l.content).concat(t.text),
                                richText: "".concat(l.richText).concat(t.text)
                            }),
                            t.text && (v = !1),
                            i.push(l)) : (i.push(l),
                            i.push(k(k({}, l), {}, {
                                _words: t.words,
                                content: "[te".concat((null == h ? void 0 : h[S.intonation]) || r[S.intonation], "][n").concat((null == h ? void 0 : h[S.number]) || r[S.number], "]").concat(t.text),
                                richText: "".concat(t.text)
                            }))),
                            b && !y && ((s += t.words) < c.startOffset || (g = i.length - 1,
                            y = !0))
                        }) : i.push(l),
                        d = h ? k({}, h) : null) : (m = $("".concat(t.nodeValue))).length ? m.forEach(function(t, e) {
                            0 < e && (l = i.pop()),
                            v && !C(t.text) || l._words < _.min || l._words < _.optimal && (!N(l.content) || l._words + t.words < _.max) || U(t.text) || !N(l.content) && !C(t.text) && l._words + t.words < _.warning ? (l = k(k({}, l), {}, {
                                _words: l._words + t.words,
                                content: "".concat(l.content).concat(t.text),
                                richText: "".concat(l.richText).concat(t.text)
                            }),
                            t.text && (v = !1),
                            i.push(l)) : (i.push(l),
                            i.push(k(k({}, l), {}, {
                                _words: t.words,
                                content: "[te".concat(r[S.intonation], "][n").concat(r[S.number], "]").concat(t.text),
                                richText: "".concat(t.text)
                            }))),
                            b && !y && ((s += t.words) < c.startOffset || (g = i.length - 1,
                            y = !0))
                        }) : i.push(l)) : (m = $("".concat(t.nodeValue)),
                        b && !y && "".concat(t.nodeValue).length === c.startOffset && (x = !0),
                        m.forEach(function(t, e) {
                            var n, r, o, a;
                            0 === e ? U(t.text) ? (i[i.length - 1] = k(k({}, i[i.length - 1]), {}, {
                                _words: i[i.length - 1]._words + t.words,
                                content: "".concat(i[i.length - 1].content).concat(t.text),
                                richText: "".concat(i[i.length - 1].richText).concat(t.text)
                            }),
                            b && !y && ((s += t.words) < c.startOffset || (g = i.length - 1,
                            y = !0))) : i.length && !i[i.length - 1]._words ? (i[i.length - 1] = {
                                tts: k({}, u),
                                _words: t.words,
                                content: "".concat(i[i.length - 1].content, "[te").concat(u.intonation, "][n").concat(u.number, "]").concat(t.text),
                                richText: "".concat(i[i.length - 1].richText).concat(t.text)
                            },
                            b && !y && ((s += t.words) < c.startOffset || (g = i.length - 1,
                            y = !0))) : (i.push({
                                tts: k({}, u),
                                _words: t.words,
                                content: "[te".concat(u.intonation, "][n").concat(u.number, "]").concat(t.text),
                                richText: "".concat(t.text)
                            }),
                            b && !y && (s += t.words,
                            c.startOffset < s && (g = i.length - 1,
                            y = !0))) : (a = "",
                            (null == u ? void 0 : u[S.vcn]) === (null === (e = i[i.length - 1]) || void 0 === e || null === (n = e.tts) || void 0 === n ? void 0 : n[S.vcn]) && (null == u ? void 0 : u[S.speed]) === (null === (n = i[i.length - 1]) || void 0 === n || null === (r = n.tts) || void 0 === r ? void 0 : r[S.speed]) && (null == u ? void 0 : u[S.volume]) === (null === (r = i[i.length - 1]) || void 0 === r || null === (o = r.tts) || void 0 === o ? void 0 : o[S.volume]) || (a = "[te".concat(u.intonation, "][n").concat(u.number, "]")),
                            U(t.text) || !a && (v && !C(t.text) || i[i.length - 1]._words < _.min || i[i.length - 1]._words < _.optimal && (!N(i[i.length - 1].content) || i[i.length - 1]._words + t.words < _.max)) ? (i[i.length - 1] = k(k({}, i[i.length - 1]), {}, {
                                _words: i[i.length - 1]._words + t.words,
                                content: "".concat(i[i.length - 1].content).concat(t.text),
                                richText: "".concat(i[i.length - 1].richText).concat(t.text)
                            }),
                            t.text && (v = !1)) : i.push({
                                tts: k({}, u),
                                _words: t.words,
                                content: "[te".concat(u.intonation, "][n").concat(u.number, "]").concat(t.text),
                                richText: "".concat(t.text)
                            }),
                            b && !y && ((s += t.words) < c.startOffset || (g = i.length - 1,
                            y = !0)))
                        }),
                        U("".concat(t.nodeValue)) || (d = h ? k({}, h) : null))
                    } else if (t.nodeType === Node.ELEMENT_NODE) {
                        if ("i" == t.nodeName.toLowerCase()) {
                            var e, a;
                            if (null !== (e = t.classList) && void 0 !== e && e.contains("tts-mark-flag") && "annotation" !== "".concat(t.dataset.type) && (i.length ? i[i.length - 1] = k(k({}, i[i.length - 1]), {}, {
                                richText: "".concat(i[i.length - 1].richText).concat(t.outerHTML)
                            }) : i.push({
                                tts: k({}, u),
                                _words: 0,
                                content: "[te".concat(u.intonation, "][n").concat(u.number, "]"),
                                richText: "".concat(t.outerHTML)
                            })),
                            null !== (e = t.classList) && void 0 !== e && e.contains("tts-mark-point"))
                                return "w" !== "".concat(t.dataset.type) && "annotation" !== "".concat(t.dataset.type) || (v = !0),
                                void ("w" === "".concat(t.dataset.type) || "p" === "".concat(t.dataset.type) ? i.length ? i[i.length - 1] = k(k({}, i[i.length - 1]), {}, {
                                    _words: i[i.length - 1]._words + t.innerText.length,
                                    content: i[i.length - 1].content + "".concat(t.dataset.tts)
                                }) : i.push({
                                    tts: k({}, u),
                                    _words: t.innerText.length,
                                    content: "[te".concat(u.intonation, "][n").concat(u.number, "]").concat(t.dataset.tts)
                                }) : "annotation" === "".concat(t.dataset.type) && (!d && !h || (null == d ? void 0 : d[S.vcn]) === (null == h ? void 0 : h[S.vcn]) && (null == d ? void 0 : d[S.speed]) === (null == h ? void 0 : h[S.speed]) && (null == d ? void 0 : d[S.volume]) === (null == h ? void 0 : h[S.volume]) ? i.length ? i[i.length - 1] = k(k({}, i[i.length - 1]), {}, {
                                    _words: i[i.length - 1]._words + t.innerText.length,
                                    content: "".concat(i[i.length - 1].content).concat(t.innerText).concat(t.dataset.tts),
                                    richText: "".concat(i[i.length - 1].richText).concat(t.outerHTML)
                                }) : i.push({
                                    tts: k({}, u),
                                    _words: t.innerText.length,
                                    content: "[te".concat(u.intonation, "][n").concat(u.number, "]").concat(t.innerText).concat(t.dataset.tts),
                                    richText: "".concat(t.outerHTML)
                                }) : (i.push({
                                    tts: k({}, u),
                                    _words: t.innerText.length,
                                    content: "[te".concat(u.intonation, "][n").concat(u.number, "]").concat(t.innerText).concat(t.dataset.tts),
                                    richText: "".concat(t.outerHTML)
                                }),
                                v = !1,
                                d = h ? k({}, h) : null)));
                            if (null !== (e = t.classList) && void 0 !== e && e.contains("mark-range-start"))
                                return void (null !== (e = t.classList) && void 0 !== e && e.contains("tts-mark-composite-vcn") ? (p = h ? k({}, h) : null,
                                (h = h || {}).vcn = (a = t.dataset).tts,
                                h.intonation = a.intonation,
                                h.speed = a.speed,
                                h.volume = a.volume,
                                f = {
                                    vcn: a.tts,
                                    intonation: a.intonation,
                                    speed: a.speed,
                                    volume: a.volume
                                }) : (h = h || {},
                                p && (p[t.dataset.type] = t.dataset.tts),
                                h[t.dataset.type] = t.dataset.tts));
                            if (null !== (a = t.classList) && void 0 !== a && a.contains("mark-range-end"))
                                return void (null !== (a = t.classList) && void 0 !== a && a.contains("tts-mark-composite-vcn") ? (h = p,
                                f = p = null) : f ? (h && (h[t.dataset.type] = f[t.dataset.type]),
                                p && delete p[t.dataset.type]) : h && (delete h[t.dataset.type],
                                Object.keys(h).length || (h = null)))
                        } else
                            "div" == t.nodeName.toLowerCase() && i.length && (i[i.length - 1] = k(k({}, i[i.length - 1]), {}, {
                                _words: i[i.length - 1]._words + 1,
                                content: "".concat(i[i.length - 1].content, "\n"),
                                richText: "".concat(i[i.length - 1].richText, "<br />")
                            }),
                            c && !y && c.path[0] === o[0] && 0 === c.path[1] && 0 === c.startOffset && (g = Math.max(i.length - 1, 0),
                            y = b = !0));
                        t.childNodes.forEach(function(t, e) {
                            e = [].concat(w(o), [e]),
                            n(t, r, i, e)
                        })
                    }
                }
                )(t, e, n, []),
                h = d = u = l = null,
                console.log(" cursorSentenceIndex calc:", g),
                g === n.length - 1 && x && (console.log("光标在最后, 自动从全文开始"),
                g = 0);
                return console.log("cursorSentenceIndex", g),
                {
                    sentences: n,
                    cursorIndex: g
                }
            }(t, e, n, r).cursorIndex
        }
    }
    function G(t) {
        return (t || "").replace(/(\[p\d+\])|(\[w[013]\])|(\[=\w+\d\])|(\[te\d+\])|(\[n\d\])/g, "").length
    }
    function $(t) {
        if (!t)
            return [];
        var t = (t || "").replace(x, "$1~~~^^^").split("~~~^^^")
          , r = [];
        return t.map(function(t) {
            var e, n = G(t);
            n <= _.max || (e = ((null === (e = t.match(/\b/g)) || void 0 === e ? void 0 : e.length) || 0) / 2) < 60 && n < _.danger ? r.push({
                text: t,
                words: n
            }) : (n = 1 >= (n = t.replace(/(.{30,250}\s+)/g, "$1~~~---").split("~~~---")).length || 5 >= e ? t.replace(/(.{20,100}(\s*|、))/g, "$1~~~---").split("~~~---") : n).forEach(function(t) {
                r.push({
                    text: t,
                    words: G(t)
                })
            })
        }),
        r
    }
    function U(t) {
        return !/[A-z0-9\u4e00-\u9fa5]/.test(t)
    }
    return function() {
        function n(t) {
            var e = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
            if (h(this, n),this._words = 0,this._emitter = new m,this._undoStack = [],this._redoStack = [],this._config = k({}, e || {}),
			this.editorSelector = t instanceof HTMLElement ? t : document.querySelector(t),
            !this.editorSelector)throw Error("Editor initialize, dom: args[0] not exist");
            this.id = "tts-editor-".concat(Math.random().toString(36).slice(-5))
        }
        var e, r, o, t, a, i, s, c, l, u;
        return p(n, [{
            key: "init",
            value: function() {
                this.initDom(this),
                this.initToolbar(this),
                this.bindEvents(this),
                this.initEditor(this),
                A(this),
                this.editorSelector.dispatchEvent(new Event("input"))
            }
        }, {
            key: "destroy",
            value: function() {}
        }, {
            key: "on",
            value: function(t, e) {
                this._emitter.on(t, e)
            }
        }, {
            key: "off",
            value: function(t, e) {
                this._emitter.on(t, e)
            }
        }, {
            key: "removeAllListeners",
            value: function(t) {
                this._emitter.removeAllListeners(t)
            }
        }, {
            key: "initDom",
            value: function(t) {
                t.editorSelector && (t.editorSelector.setAttribute("contenteditable", !0),
                t.editorSelector.setAttribute("empty", "true"),
                t.editorSelector.classList.add("tts-mark-editor"),
                t.editorSelector.style.width = "100%",
                t.editorSelector.style.position = "relative",
                t.editorSelector.style.overflow = "auto")
            }
        }, {
            key: "initToolbar",
            value: function(t) {}
        }, {
            key: "initEditor",
            value: function(t) {
                this._maxWords = this._config.maxWords || 1 / 0
            }
        }, {
            key: "bindEvents",
            value: function(n) {
                var r = this;
                function t(t) {
                    "compositionstart" === t.type ? L.status = "compositionstart" : "compositionend" === t.type && (L.status = "",
                    n.__emitContentChange())
                }
                this._emitter.on("words", function(t) {
                    0 < t || null !== n.editorSelector.querySelector("i") ? n.editorSelector.setAttribute("empty", "") : n.editorSelector.setAttribute("empty", !0)
                }),
                n.editorSelector.addEventListener("focus", function(t) {
                    A(n),
                    R(),
                    setTimeout(function() {
                        r.storeRange(n)
                    })
                }),
                n.editorSelector.addEventListener("blur", function(t) {
                    r.storeRange(n)
                }),
                n.editorSelector.addEventListener("click", function(t) {
                    var e;
                    null !== (e = t.target.classList) && void 0 !== e && e.contains("tts-range-remove") ? (t.target.parentNode.parentNode.removeChild(t.target.parentNode),
                    q(n)) : setTimeout(function() {
                        R()
                    })
                }),
                n.editorSelector.addEventListener("keydown", function(t) {
                    if ((t.ctrlKey || t.metaKey) && 90 === t.keyCode)
                        return t.preventDefault(),
                        void (t.shiftKey ? r.redo() : r.undo());
                    var e = r.editorLimitCheck(t);
                    if (e.limit && !(8 === t.keyCode || 46 === t.keyCode || t.ctrlKey || t.metaKey || (t.ctrlKey || t.metaKey) && 65 == t.keyCode || (t.ctrlKey || t.metaKey) && 90 == t.keyCode || (t.ctrlKey || t.metaKey) && 67 == t.keyCode))
                        return t.preventDefault();
                    8 === t.keyCode ? q(r) : 13 === t.keyCode && (t.preventDefault(),
                    P(n),
                    n.editorSelector.dispatchEvent(new Event("input")))
                }),
                n.editorSelector.addEventListener("keyup", function(t) {
                    8 === t.keyCode && (A(n),
                    n.editorSelector.blur(),
                    r.restoreRange(r))
                }),
                n.editorSelector.addEventListener("paste", function(t) {
                    var o;
                    return o = t,
                    new Promise(function(t, e) {
                        var n = "";
                        if (null != o && o.clipboardData)
                            return n = (n = o.clipboardData.getData("text/plain")).replace(/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g, ""),
                            o.preventDefault(),
                            t(n);
                        var r = document.createElement("input");
                        r.style.position = "fixed",
                        r.style.left = "-100px",
                        r.style.top = "0",
                        r.style.height = "1px",
                        r.style.width = "1px",
                        r.value = "",
                        document.body.appendChild(r),
                        setTimeout(function() {
                            n = r.value.replace(/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g, ""),
                            t(n),
                            document.body.removeChild(r)
                        }),
                        r.focus()
                    }
                    ).then(function(t) {
                        var e = r.editorLimitCheck();
                        if (e.limit)
                            return console.warn("超过限制");
                        0 < e.diff && (e.diff < t.length && console.warn("粘贴文本超过限制，截取处理"),
                        t = t.substr(0, e.diff)),
                        r.restoreRange(n),
                        document.execCommand("insertText", !1, t)
                    }).catch(function(t) {
                        console.error("剪贴板数据获取异常", t),
                        alert("剪贴板数据获取异常")
                    }),
                    !1
                }),
                n.editorSelector.addEventListener("redoundo", function(t) {
                    var e = n.editorSelector.querySelectorAll(".tts-content-paragraph").length
                      , t = Math.max(K((n.editorSelector.innerText || "").replace(/\n/g, "")) + e - 1 - ("compositionstart" === L.status ? t.data.replace(/[^\s]/g, "").length : 0), 0);
                    r._words = t,
                    r._emitter.emit("words", t),
                    n.__emitContentChange({
                        ignoreUndo: !0
                    })
                }),
                n.editorSelector.addEventListener("input", function(t) {
                    var e = n.editorSelector.querySelectorAll(".tts-content-paragraph").length
                      , t = Math.max(K((n.editorSelector.innerText || "").replace(/\n/g, "")) + e - 1 - ("compositionstart" === L.status ? t.data.replace(/[^\s]/g, "").length : 0), 0);
                    r._words = t,
                    r._emitter.emit("words", t),
                    "compositionstart" !== L.status && n.__emitContentChange()
                }),
                n.editorSelector.addEventListener("compositionstart", t),
                n.editorSelector.addEventListener("compositionupdate", t),
                n.editorSelector.addEventListener("compositionend", t)
            }
        }, {
            key: "editorLimitCheck",
            value: function() {
                var t = this.editorSelector.querySelectorAll(".tts-content-paragraph").length
                  , t = Math.max(K(this.editorSelector.innerText.replace(/\n/g, "")) + t - 1, 0);
                return t < this._maxWords ? {
                    words: t,
                    limit: !1,
                    diff: this._maxWords - t
                } : {
                    words: t,
                    limit: !0,
                    diff: this._maxWords - t
                }
            }
        }, {
            key: "setMaxWords",
            value: function(t) {
                this._maxWords = t
            }
        }, {
            key: "getRange",
            value: function() {
                var t = window.getSelection();
                if (!t.rangeCount)
                    return null;
                var e = t.getRangeAt(0)
                  , n = document.createRange();
                n.selectNode(this.editorSelector);
                t = e.compareBoundaryPoints(Range.START_TO_START, n),
                n = e.compareBoundaryPoints(Range.END_TO_END, n);
                return t < 0 || 0 < n ? null : {
                    startContainer: F(e.startContainer, this.editorSelector),
                    startOffset: e.startOffset,
                    endContainer: F(e.endContainer, this.editorSelector),
                    endOffset: e.endOffset,
                    collapsed: e.collapsed,
                    commonAncestorContainer: F(e.commonAncestorContainer, this.editorSelector),
                    innerText: "" + e
                }
            }
        }, {
            key: "setRange",
            value: function(t) {
                try {
                    var e, n, r, o;
                    this.editorSelector.focus(),
                    t && ((e = window.getSelection()).removeAllRanges(),
                    n = document.createRange(),
                    r = V(w(t.startContainer), this.editorSelector),
                    o = V(w(t.endContainer), this.editorSelector),
                    n.setStart(r, t.startOffset),
                    n.setEnd(o, t.endOffset),
                    e.addRange(n))
                } catch (t) {
                    console.warn("set range warning", t)
                }
            }
        }, {
            key: "storeRange",
            value: function() {
                var t = window.getSelection();
                if (!t.rangeCount)
                    return this.currentSelection = null;
                var e = t.getRangeAt(0)
                  , n = document.createRange();
                n.selectNode(this.editorSelector);
                t = e.compareBoundaryPoints(Range.START_TO_START, n),
                n = e.compareBoundaryPoints(Range.END_TO_END, n);
                t < 0 || 0 < n || (this.currentSelection = {
                    startContainer: e.startContainer,
                    startOffset: e.startOffset,
                    endContainer: e.endContainer,
                    endOffset: e.endOffset,
                    collapsed: e.collapsed,
                    commonAncestorContainer: e.commonAncestorContainer,
                    innerText: "" + e
                })
            }
        }, {
            key: "restoreRange",
            value: function(t) {
                var e, n;
                t.currentSelection && ((e = window.getSelection()).removeAllRanges(),
                (n = document.createRange()).setStart(t.currentSelection.startContainer, t.currentSelection.startOffset),
                n.setEnd(t.currentSelection.endContainer, t.currentSelection.endOffset),
                e.addRange(n),
                t.currentSelection = null),
                t.editorSelector.focus()
            }
        }, {
            key: "insertPause",
            value: function(t) {
                var e, n = this;
                if (this.storeRange(this),
                !this.currentSelection)
                    return Promise.reject(Error("请点击使光标定位到插入位置"));
                t && !isNaN(t) && (e = H({
                    tts: "[".concat(t / 1e3, "s]"),
                    label: "".concat(t / 1e3, "秒"),
                    className: "tts-mark-pause",
                    markType: "p"
                }),
                document.createDocumentFragment().appendChild(e),
                (t = document.createRange()).setStart(this.currentSelection.startContainer, this.currentSelection.startOffset),
                t.setEnd(this.currentSelection.endContainer, this.currentSelection.endOffset),
                t.collapse(),
                t.insertNode(e),
                t.selectNode(e),
                t.collapse(),
                this.restoreRange(this),
                setTimeout(function() {
                    n.editorSelector.dispatchEvent(new Event("input"))
                }))
            }
        }, {
            key: "insertContinuity",
            value: (u = d(f.mark(function t() {
                var e, n, r = this;
                return f.wrap(function(t) {
                    for (; ; )
                        switch (t.prev = t.next) {
                        case 0:
                            if (this.currentSelection) {
                                t.next = 2;
                                break
                            }
                            return t.abrupt("return", Promise.reject(Error("请点击使光标定位到插入位置")));
                        case 2:
                            e = H({
                                tts: "[continuity]",
                                label: "连读",
                                className: "tts-mark-continuity",
                                markType: "lx"
                            }),
                            document.createDocumentFragment().appendChild(e),
                            (n = document.createRange()).setStart(this.currentSelection.startContainer, this.currentSelection.startOffset),
                            n.setEnd(this.currentSelection.endContainer, this.currentSelection.endOffset),
                            n.collapse(),
                            n.insertNode(e),
                            n.selectNode(e),
                            n.collapse(),
                            this.restoreRange(this),
                            setTimeout(function() {
                                r.editorSelector.dispatchEvent(new Event("input"))
                            });
                        case 14:
                        case "end":
                            return t.stop()
                        }
                }, t, this)
            })),
            function() {
                return u.apply(this, arguments)
            }
            )
        }, {
            key: "insertSegmentation",
            value: (l = d(f.mark(function t() {
                var e, n, r = this;
                return f.wrap(function(t) {
                    for (; ; )
                        switch (t.prev = t.next) {
                        case 0:
                            if (this.currentSelection) {
                                t.next = 2;
                                break
                            }
                            return t.abrupt("return", Promise.reject(Error("请点击使光标定位到插入位置")));
                        case 2:
                            e = H({
                                tts: "[punctuation]",
                                label: "断句",
                                className: "tts-mark-segmentation",
                                markType: "dj"
                            }),
                            document.createDocumentFragment().appendChild(e),
                            (n = document.createRange()).setStart(this.currentSelection.startContainer, this.currentSelection.startOffset),
                            n.setEnd(this.currentSelection.endContainer, this.currentSelection.endOffset),
                            n.collapse(),
                            n.insertNode(e),
                            n.selectNode(e),
                            n.collapse(),
                            this.restoreRange(this),
                            setTimeout(function() {
                                r.editorSelector.dispatchEvent(new Event("input"))
                            });
                        case 14:
                        case "end":
                            return t.stop()
                        }
                }, t, this)
            })),
            function() {
                return l.apply(this, arguments)
            }
            )
        }, {
            key: "__emitContentChange",
            value: function(t) {
                var r = this;
                this._emitter.emit("content-change"),
                null != t && t.ignoreUndo || (clearTimeout(this.$editContentChangeTimer),
                this.$editContentChangeTimer = setTimeout(function() {
                    var t, e, n = r.getHtml();
                    r._undoStack.length && (null === (t = r._undoStack) || void 0 === t || null === (e = t[r._undoStack.length - 1]) || void 0 === e ? void 0 : e.html) === n || (e = r.getRange(),
                    r._undoStack.push({
                        range: e,
                        html: n
                    }),
                    r._redoStack = [],
                    r._emitter.emit("can-undo", 1 < r._undoStack.length),
                    r._emitter.emit("can-redo", !1)),
                    21 < r._undoStack.length && r._undoStack.splice(0, r._undoStack.length - 20 - 1)
                }, 200))
            }
        }, {
            key: "undo",
            value: function() {
                var t;
                this._undoStack.length ? (1 < this._undoStack.length && (this._redoStack.push(this._undoStack.pop()),
                this.setHtml((t = this._undoStack[this._undoStack.length - 1]).html, {
                    redoundo: !0,
                    range: t.range
                })),
                this._emitter.emit("can-undo", 1 < this._undoStack.length)) : this._emitter.emit("can-undo", !1),
                this._emitter.emit("can-redo", !!this._redoStack.length)
            }
        }, {
            key: "redo",
            value: function() {
                var t;
                this._redoStack.length ? (t = this._redoStack.pop(),
                this.setHtml(t.html, {
                    redoundo: !0,
                    range: t.range
                }),
                this._undoStack.push(t),
                this._emitter.emit("can-redo", !!this._redoStack.length)) : (this._redoStack = [],
                this._emitter.emit("can-redo", !1)),
                this._emitter.emit("can-undo", 1 < this._undoStack.length)
            }
        }, {
            key: "insertAnnotation",
            value: (c = d(f.mark(function t(e) {
                var n, r;
                return f.wrap(function(t) {
                    for (; ; )
                        switch (t.prev = t.next) {
                        case 0:
                            if (this._words) {
                                t.next = 2;
                                break
                            }
                            return t.abrupt("return", Promise.reject(Error("请输入文本")));
                        case 2:
                            r = H({
                                tts: "[=de1]",
                                label: "[de1]",
                                className: "tts-mark-annotation",
                                text: "的",
                                markType: "annotation"
                            }),
                            (n = document.createDocumentFragment()).appendChild(r),
                            r = window.getSelection(),
                            (r = r.getRangeAt(0)).collapse(),
                            r.insertNode(n),
                            r.collapse(),
                            this.storeRange(this),
                            this.restoreRange(this);
                        case 12:
                        case "end":
                            return t.stop()
                        }
                }, t, this)
            })),
            function(t) {
                return c.apply(this, arguments)
            }
            )
        }, {
            key: "wrapNumber",
            value: (s = d(f.mark(function t() {
                var e, n, r, o = arguments;
                return f.wrap(function(t) {
                    for (; ; )
                        switch (t.prev = t.next) {
                        case 0:
                            e = 0 < o.length && void 0 !== o[0] ? o[0] : 0,
                            n = this,
                            r = "",
                            t.t0 = e,
                            t.next = 1 === t.t0 ? 6 : 2 === t.t0 ? 8 : 10;
                            break;
                        case 6:
                            return r = "读数字",
                            t.abrupt("break", 10);
                        case 8:
                            return r = "读数值",
                            t.abrupt("break", 10);
                        case 10:
                            if (r) {
                                t.next = 12;
                                break
                            }
                            return t.abrupt("return", Promise.reject(Error("不支持读数字读法标注")));
                        case 12:
                            if (!this.currentSelection || this.currentSelection.collapsed)
                                return t.abrupt("return", Promise.reject(Error("请先选中需指定读法的文本")));
                            t.next = 14;
                            break;
                        case 14:
                            if (/\d/.test(this.currentSelection.innerText)) {
                                t.next = 16;
                                break
                            }
                            return t.abrupt("return", Promise.reject(Error("选中文本必须包含数字")));
                        case 16:
                            W(n, {
                                tts: "".concat(e),
                                label: r,
                                ttsMarkClass: "tts-mark-number",
                                markType: S.number
                            }),
                            n.editorSelector.dispatchEvent(new Event("input"));
                        case 18:
                        case "end":
                            return t.stop()
                        }
                }, t, this)
            })),
            function() {
                return s.apply(this, arguments)
            }
            )
        }, {
            key: "wrapSpeed",
            value: (i = d(f.mark(function t() {
                var e, n, r = arguments;
                return f.wrap(function(t) {
                    for (; ; )
                        switch (t.prev = t.next) {
                        case 0:
                            if (n = this,
                            void 0 === (e = 0 < r.length && void 0 !== r[0] ? r[0] : {
                                speed: 0,
                                label: "1.0x"
                            }).speed)
                                return t.abrupt("return", Promise.reject(Error("请选择语速")));
                            t.next = 4;
                            break;
                        case 4:
                            if (!this.currentSelection || this.currentSelection.collapsed)
                                return t.abrupt("return", Promise.reject(Error("请先选中需调节语速的文本")));
                            t.next = 6;
                            break;
                        case 6:
                            W(n, {
                                tts: "".concat(e.speed),
                                label: "语速".concat(e.label),
                                ttsMarkClass: "tts-mark-speed",
                                markType: S.speed
                            }),
                            n.editorSelector.dispatchEvent(new Event("input"));
                        case 8:
                        case "end":
                            return t.stop()
                        }
                }, t, this)
            })),
            function() {
                return i.apply(this, arguments)
            }
            )
        }, {
            key: "wrapIntonation",
            value: (a = d(f.mark(function t() {
                var e, n, r = arguments;
                return f.wrap(function(t) {
                    for (; ; )
                        switch (t.prev = t.next) {
                        case 0:
                            if (n = this,
                            e = 0 < r.length && void 0 !== r[0] ? r[0] : 50) {
                                t.next = 4;
                                break
                            }
                            return t.abrupt("return", Promise.reject(Error("请选择语调")));
                        case 4:
                            if (!this.currentSelection || this.currentSelection.collapsed)
                                return t.abrupt("return", Promise.reject(Error("请先选中需调节语调的文本")));
                            t.next = 6;
                            break;
                        case 6:
                            W(n, {
                                tts: "".concat(e),
                                label: "语调".concat(e),
                                ttsMarkClass: "tts-mark-intonation",
                                markType: S.intonation
                            }),
                            n.editorSelector.dispatchEvent(new Event("input"));
                        case 8:
                        case "end":
                            return t.stop()
                        }
                }, t, this)
            })),
            function() {
                return a.apply(this, arguments)
            }
            )
        }, {
            key: "wrapVolume",
            value: (t = d(f.mark(function t() {
                var e, n, r = arguments;
                return f.wrap(function(t) {
                    for (; ; )
                        switch (t.prev = t.next) {
                        case 0:
                            if (n = this,
                            e = 0 < r.length && void 0 !== r[0] ? r[0] : 100) {
                                t.next = 4;
                                break
                            }
                            return t.abrupt("return", Promise.reject(Error("请选择音量")));
                        case 4:
                            if (!this.currentSelection || this.currentSelection.collapsed)
                                return t.abrupt("return", Promise.reject(Error("请先选中需调节主播音量的文本")));
                            t.next = 6;
                            break;
                        case 6:
                            W(n, {
                                tts: "".concat(e),
                                label: "音量".concat(e),
                                ttsMarkClass: "tts-mark-volume",
                                markType: S.volume
                            }),
                            n.editorSelector.dispatchEvent(new Event("input"));
                        case 8:
                        case "end":
                            return t.stop()
                        }
                }, t, this)
            })),
            function() {
                return t.apply(this, arguments)
            }
            )
        }, {
            key: "wrapSpeaker",
            value: (o = d(f.mark(function t(e) {
                var n, r, o;
                return f.wrap(function(t) {
                    for (; ; )
                        switch (t.prev = t.next) {
                        case 0:
                            if (n = (o = e || {}).vcn,
                            r = o.name,
                            o = this,
                            n) {
                                t.next = 4;
                                break
                            }
                            return t.abrupt("return", Promise.reject(Error("请选择发音人")));
                        case 4:
                            if (!this.currentSelection || this.currentSelection.collapsed)
                                return t.abrupt("return", Promise.reject(Error("请先选中需指定发音人的文本")));
                            t.next = 6;
                            break;
                        case 6:
                            W(o, {
                                tts: n,
                                label: r,
                                ttsMarkClass: "tts-mark-vcn",
                                markType: S.vcn
                            }),
                            o.editorSelector.dispatchEvent(new Event("input"));
                        case 8:
                        case "end":
                            return t.stop()
                        }
                }, t, this)
            })),
            function(t) {
                return o.apply(this, arguments)
            }
            )
        }, {
            key: "wrapCompsiteSpeaker",
            value: (r = d(f.mark(function t(e) {
                var n, r, o, a, i, s;
                return f.wrap(function(t) {
                    for (; ; )
                        switch (t.prev = t.next) {
                        case 0:
                            if (n = (s = e || {}).vcn,
                            r = s.name,
                            o = s.intonation,
                            a = s.speed,
                            i = s.volume,
                            s = this,
                            n) {
                                t.next = 4;
                                break
                            }
                            return t.abrupt("return", Promise.reject(Error("请选择收藏发音人")));
                        case 4:
                            if (!this.currentSelection || this.currentSelection.collapsed)
                                return t.abrupt("return", Promise.reject(Error("请先选中需指定收藏发音人的文本")));
                            t.next = 6;
                            break;
                        case 6:
                            W(s, {
                                tts: n,
                                intonation: o,
                                speed: a,
                                volume: i,
                                label: r,
                                ttsMarkClass: "tts-mark-composite-vcn",
                                markType: S.composite_vcn
                            }),
                            s.editorSelector.dispatchEvent(new Event("input"));
                        case 8:
                        case "end":
                            return t.stop()
                        }
                }, t, this)
            })),
            function(t) {
                return r.apply(this, arguments)
            }
            )
        }, {
            key: "getHtml",
            value: function() {
                return this.editorSelector.innerHTML
            }
        }, {
            key: "setHtml",
            value: function(t, e) {
                var n = this
                  , e = e || {}
                  , r = e.redoundo
                  , o = e.range
                  , a = this;
                this.editorSelector.innerHTML = t,
                setTimeout(function() {
                    r || q(a),
                    n.editorSelector.dispatchEvent(new Event(r ? "redoundo" : "input")),
                    n.setRange(o)
                })
            }
        }, {
            key: "getWords",
            value: function() {
                return this._words
            }
        }, {
            key: "getTtsText",
            value: (e = d(f.mark(function t(e) {
                var n, r, o;
                return f.wrap(function(t) {
                    for (; ; )
                        switch (t.prev = t.next) {
                        case 0:
                            return n = null,
                            this.currentSelection && (o = this.currentSelection.startOffset,
                            console.log("start", r = this.currentSelection.startContainer),
                            console.log("startOffset", o),
                            n = {
                                path: j(r, this.editorSelector, o),
                                startOffset: r.nodeType === Node.ELEMENT_NODE ? 0 : o
                            }),
                            t.abrupt("return", X(this.editorSelector, e, n));
                        case 3:
                        case "end":
                            return t.stop()
                        }
                }, t, this)
            })),
            function(t) {
                return e.apply(this, arguments)
            }
            )
        }, {
            key: "getPlainText",
            value: function() {
                return this.editorSelector.innerText
            }
        }, {
            key: "getTtsSpeakers",
            value: function(t) {
                var e = {};
                return t && t.vcn && (e[t.vcn] = {
                    vcn: t.vcn,
                    name: t.name
                }),
                this.editorSelector.querySelectorAll(".tts-mark-vcn.mark-range-start").forEach(function(t) {
                    t.dataset.tts && !e[t.dataset.tts] && (e[t.dataset.tts] = {
                        vcn: t.dataset.tts,
                        name: t.dataset.label
                    })
                }),
                this.editorSelector.querySelectorAll(".tts-mark-composite-vcn.mark-range-start").forEach(function(t) {
                    t.dataset.tts && !e[t.dataset.tts] && (e[t.dataset.tts] = {
                        vcn: t.dataset.tts,
                        name: t.dataset.label
                    })
                }),
                Object.keys(e).map(function(t) {
                    return e[t]
                })
            }
        }, {
            key: "isSelectionOpened",
            value: function() {
                var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : "speaker"
                  , e = {
                    opened: !0,
                    message: ""
                };
                return !this.currentSelection || this.currentSelection.collapsed ? e.opened = !1 : "number" !== t || /\d/.test(this.currentSelection.innerText) || (e.opened = !1,
                e.message = "选中文本需要包含数字哟"),
                e
            }
        }]),
        n
    }()
});
//# sourceMappingURL=tts-editor.min.js.map
